// SPDX-License-Identifier: AGPL-3.0-or-later

import {SystemMessage} from '@app/features/channel/components/SystemMessage';
import {SystemMessageUsername} from '@app/features/channel/components/SystemMessageUsername';
import {PadNoticeChanges} from '@app/features/konvo_scratchpad/components/ScratchpadChanges';
import KonvoChannelScratchpad from '@app/features/konvo_scratchpad/state/KonvoChannelScratchpad';
import KonvoScratchpad from '@app/features/konvo_scratchpad/state/KonvoScratchpad';
import {useSystemMessageData} from '@app/features/messaging/hooks/useSystemMessageData';
import type {Message} from '@app/features/messaging/models/MessagingMessage';
import styles from '@app/features/theme/styles/Message.module.css';
import {ScratchpadIcon} from '@app/features/ui/icons/ScratchpadIcon';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import {useCallback} from 'react';

interface SharedPadUpdateMessageProps {
	message: Message;
}

export const SharedPadUpdateMessage = observer(({message}: SharedPadUpdateMessageProps) => {
	const {author, channel, guild} = useSystemMessageData(message);
	const openSharedPad = useCallback(() => {
		KonvoScratchpad.openShared(message.channelId);
	}, [message.channelId]);
	if (!channel) return null;
	const messageContent = (
		<Trans>
			<SystemMessageUsername
				key={author.id}
				author={author}
				guild={guild}
				message={message}
				data-flx="channel.shared-pad-update-message.system-message-username"
			/>{' '}
			updated the{' '}
			<PadNoticeChanges
				pad={KonvoChannelScratchpad.get(message.channelId)}
				userId={author.id}
				noticeAt={message.timestamp}
				className={styles.systemMessageLink}
				onClick={openSharedPad}
				flx="channel.shared-pad-update-message.open-shared-pad"
			>
				shared pad
			</PadNoticeChanges>
			.
		</Trans>
	);
	return (
		<SystemMessage
			icon={ScratchpadIcon}
			iconWeight="bold"
			message={message}
			messageContent={messageContent}
			data-flx="channel.shared-pad-update-message.system-message"
		/>
	);
});
